import axios from "axios";
import qs from "qs";

const getOAuthToken = ({ baseUrl, code, clientId, clientSecret }) =>
  axios({
    method: "POST",
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    data: qs.stringify({
      grant_type: "authorization_code",
      code,
      client_id: clientId,
      client_secret: clientSecret,
      redirect_uri: `${window.location.origin}/organizations/general/salesforce-connection-callback`
    }),
    url: `${baseUrl}/services/oauth2/token`
  })
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err.response));

const methods = {
  getOAuthToken
};

export default methods;
